// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"be141e17","691":"d8d7266a"}[chunkId] + ".chunk.js";
};